export var ProjectDataLayer;
(function (ProjectDataLayer) {
    ProjectDataLayer["ClickHouse"] = "ch";
    ProjectDataLayer["ElasticSearch"] = "es";
    ProjectDataLayer["Redshift"] = "rs";
})(ProjectDataLayer || (ProjectDataLayer = {}));
//# sourceMappingURL=project.datalayer.js.map